import StageFilesOrder from './StageFilesOrder.component';

export default StageFilesOrder;
